import DashboardProviderList from "../components/Dashboard/DashboardProviderList"
import DashboardProviderSearch from "../components/Dashboard/DashboardProviderSearch"

interface DashboardPropTypes {

}

const Dashboard = (props : DashboardPropTypes) => {
  return (
    <>
    <DashboardProviderSearch/>
    <DashboardProviderList/>
    </>
  )
}

export default Dashboard